import { estruturaItensMap } from '../risrotEstruturaCatalog';
import RisrotEstruturaTable from './RisrotEstruturaTable';
import type { RisrotEstruturaBaseProps } from './RisrotEstruturaTable';

const ESTRUTURA = 'Talude de jusante' as const;

export default function EstruturaTaludeJusante(props: RisrotEstruturaBaseProps) {
	return (
		<RisrotEstruturaTable
			{...props}
			structureName={ESTRUTURA}
			fixedItems={estruturaItensMap[ESTRUTURA]}
		/>
	);
}
